
import axios from "axios";

// const URL = "http://ec2-54-233-95-90.sa-east-1.compute.amazonaws.com:9005";
const URL = "https://microservicoacbr.kiron.net.br:8443";


const apiAcbr = axios.create({
    timeout: 20000,
    baseURL: URL,
    // headers: {                  
    //       "Access-Control-Allow-Origin": "*",
    //       "Access-Control-Allow-Headers": "Authorization", 
    //       "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE" ,
    //       "Content-Type": "application/json;charset=UTF-8",
    //       "Cache-Control": "max-age=300"                
    //   },


});


export default apiAcbr;
